import { render } from "./B2bTableCoacsuRecibidos.vue?vue&type=template&id=235d7928&scoped=true&lang=pug"
import script from "./B2bTableCoacsuRecibidos.vue?vue&type=script&lang=js"
export * from "./B2bTableCoacsuRecibidos.vue?vue&type=script&lang=js"

import "./B2bTableCoacsuRecibidos.vue?vue&type=style&index=0&id=235d7928&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235d7928"]])

export default __exports__